import React from 'react';
import styled, { css } from 'styled-components';
import abbreviate from 'number-abbreviate';

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 1.35rem;
  font-weight: 700;
  color: ${({ theme }) => theme.less.textColor};
`;

const Value = styled.td`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ theme }) => theme.less.primaryColor};
  padding: 5px 0;
  padding-inline-end: 15px;
  width: 0%;
`;

const Description = styled.td`
  position: relative;
  font-size: 1rem;
  color: ${({ theme }) => theme.less.textColor};
  opacity: 0.75;

  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  line-height: 2.1;

  ${({ $alt }) => $alt && css`
    opacity: 0.4;
    &:before { content: "(" }
    &:after { content: ')' }
  `};

  text-align: left;

  ${({ capitalize }) => capitalize && css`
    text-transform: capitalize;
  `};
`;

const Bar = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 80%;
  background-color: ${({ theme }) => theme.less.primaryColor};
  opacity: 0.25;
  border-radius: 8px;
  z-index: -1;
`;

const Stats = ({ data, percent = false, capitalize = false, max = 12 }) => (
  <Column>
    <Title>{data.label}</Title>
    <table>
      <tbody>
        {data.items.slice(0, max).map((item) => (
          <tr key={item.value}>
            <Value>
              {
                percent
                ? `${Math.round(
                    (item.pageviews / data.pageviews.sum) * 100
                  )}%`
                : abbreviate(item.pageviews, 1)
              }
            </Value>
            <Description
              title={item.value}
              $alt={item.value === 'direct'}
              capitalize={capitalize}
            >
              {
                percent
                ? (
                    <Bar
                      style={{
                        width: `${Math.round(
                          (item.pageviews / data.pageviews.sum) * 100
                        )}%`,
                      }}
                    />
                  )
                : null
              }
              {item.value}
            </Description>
          </tr>
        ))}
      </tbody>
    </table>
  </Column>
);

export default Stats;
